var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 0.5,
    y: 1.35059,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#141BEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6601 12.0843C26.3531 11.814 25.8708 11.7753 25.3722 11.9831H25.3713C24.8469 12.2016 10.5265 18.5783 9.94356 18.8388C9.83753 18.8771 8.91149 19.2358 9.00688 20.0348C9.09203 20.7552 9.8363 21.0535 9.92719 21.0879L13.5679 22.3821C13.8094 23.2168 14.6998 26.2963 14.8967 26.9542C15.0196 27.3644 15.2198 27.9033 15.5706 28.0142C15.8785 28.1374 16.1847 28.0248 16.3828 27.8633L18.6087 25.72L22.2019 28.6292L22.2874 28.6823C22.5314 28.7945 22.7652 28.8506 22.9883 28.8506C23.1606 28.8506 23.326 28.817 23.4841 28.7499C24.0224 28.5204 24.2377 27.9878 24.2603 27.9275L26.9442 13.4447C27.108 12.6712 26.8803 12.2777 26.6601 12.0843ZM16.7787 22.8997L15.5505 26.2997L14.3224 22.0497L23.7383 14.8247L16.7787 22.8997Z",
    fill: "#141BEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b963adad554a23c0bc55ddfcc90371f9.svg";
export { ForwardRef as ReactComponent };